module.exports = __webpack_public_path__ + "img/How-to-make-a-background-white.5305bada.png";